import { h } from 'preact';
import { PAYSAGE } from '../../../../../core/dom/types';
import { usePlayerContext, useStyles } from '../../../../common/hooks';
import { connect, withBreakPoints } from '../../../hoc';
import { mapKeyBreakpointToContainer } from '../../../utils/tools';
import { Button } from '../../common';
import { EXP_CONTROL_ICON_STYLES } from '../../controls/exp/styles';
import { ERROR_STYLES } from '../../error/styles';
import BabyPlayer from '../../recommendations/BabyPlayer';
import RecommendationsCard from '../../recommendations/RecommendationsCard';
import { RECOMMANDATIONS_CONTAINER_STYLE, RECOMMANDATIONS_CONTAINER_VERTICAL_STYLE, RECOMMANDATIONS_FULLSCREEN_BUTTON_STYLE } from './styles';

function Recommendations({
  playerImage,
  recommendations,
  hideVideo,
  shouldDisplay,
  isFullscreen,
  orientation,
  isLegacyReco
}) {
  const player = usePlayerContext();
  const setStyles = useStyles();

  return (
    isLegacyReco && shouldDisplay && (
      <div role="button" tabIndex={0} onKeyDown={() => { }} onClick={(e) => { e.stopPropagation(); }} style={setStyles(orientation === PAYSAGE ? RECOMMANDATIONS_CONTAINER_STYLE : RECOMMANDATIONS_CONTAINER_VERTICAL_STYLE)}>
        <BabyPlayer image={playerImage} hideVideo={hideVideo} />
        {recommendations.map(({
          image,
          badge,
          iconChannel,
          iconCsa,
          title,
          synopsis,
          subTitle,
          duration,
          metadata
        }, index) => (
          <RecommendationsCard
            image={image}
            badge={badge}
            iconChannel={iconChannel}
            iconCsa={iconCsa}
            title={title}
            synopsis={synopsis}
            subTitle={subTitle}
            duration={duration}
            metadata={metadata}
            index={index}
          />
        ))}
        <div style={ERROR_STYLES.errorIcon}>
          {isFullscreen
            && (
              <Button
                label="Quitter le plein écran (f)"
                ariaLabel="Quitter le plein écran (f)"
                onClick={() => {
                  player.fullscreen(!isFullscreen);
                }}
                type="icon"
                icon="fullscreen-on"
                size={setStyles(mapKeyBreakpointToContainer(EXP_CONTROL_ICON_STYLES)).size}
                style={setStyles(RECOMMANDATIONS_FULLSCREEN_BUTTON_STYLE)}
                last
                xs
              />
            )}
        </div>
      </div>
    )
  );
}
const selector = (state) => {
  const {
    ui: { isFullscreen, orientation },
    recommendations: {
      shouldDisplay,
      hideVideo,
      recos,
      isLegacy
    },
    media: { backgroundImage }
  } = state;
  return {
    playerImage: backgroundImage,
    recommendations: recos,
    shouldDisplay,
    hideVideo,
    isFullscreen,
    orientation,
    isLegacyReco: isLegacy
  };
};

export default withBreakPoints(connect(selector)(Recommendations));
